<div class="branch-details">

    <div *ngIf="branch.value.id !== 0 || editMode" class="title-header">
        <div class="title-left">
            <span class="material-icons-outlined">domain</span>
            <span class="title-text">{{ branchTitle | translate }}</span>
        </div>
        <div class="header-buttons" *ngIf="supervisor">
            <ng-container *ngIf="!editMode">
                <button class="btn-edit" (click)="toggleEditMode()">
                    <span class="material-icons-outlined">edit</span>
                </button>
                <button class="btn-delete" (click)="deleteBranch()">
                    <span class="material-icons-outlined">delete</span>
                </button>
            </ng-container>
            <ng-container *ngIf="editMode">
                <action-button
                    class="btn-save"
                    (actionEvent)="saveBranch($event)"
                    icon="save">
                </action-button>
                <button class="btn-cancel" (click)="toggleEditMode()">
                    <span class="material-icons-outlined">cancel</span>
                </button>
            </ng-container>
        </div>
    </div>

    <div *ngIf="BranchEmpty()" class="empty-details">
        <span class="material-icons-outlined">domain</span>
    </div>

    <div *ngIf="branch.value.id !== 0 || editMode" class="branch-info-container">

        <div *ngIf="branch.value.id !== 0 && !editMode" class="branch-info">
            <table>
                <tr class="info-row">
                    <td><strong class="label">{{ "branchDetails.nameLabel" | translate }}</strong></td>
                    <td><span class="value">{{ branch.value.name }}</span></td>
                </tr>
                <tr class="info-row">
                    <td><strong class="label">{{ "branchDetails.abbreviationLabel" | translate }}</strong></td>
                    <td><span class="abbr-badge">{{ branch.value.abbreviation }}</span></td>
                </tr>
            </table>
            <messages
                class="message"
                [form]="branchForm"
                [messagesObserver]="messages"
                fieldname="branch"
                [showNonFieldKeys]="TRUE"
                [showFieldName]="TRUE"
                [showFieldKeys]="TRUE">
            </messages>
        </div>

        <form [formGroup]="branchForm" *ngIf="editMode" class="branch-form">
            <div class="form-group">
                <label for="name">{{ "branchDetails.nameLabel" | translate }}</label>
                <input type="text" id="name" formControlName="name" />
                <messages [form]="branchForm" [messagesObserver]="messages" fieldname="name"></messages>
            </div>
            <div class="form-group">
                <label for="abbreviation">{{ "branchDetails.abbreviationLabel" | translate }}</label>
                <input type="text" id="abbreviation" formControlName="abbreviation" />
                <messages [form]="branchForm" [messagesObserver]="messages" fieldname="abbreviation"></messages>
            </div>
            <messages
                class="message"
                [form]="branchForm"
                [messagesObserver]="messages"
                fieldname="branch"
                [showNonFieldKeys]="TRUE"
                [showFieldName]="TRUE"
                [showFieldKeys]="TRUE">
            </messages>
        </form>

    </div>
</div>
